import { sessionManager } from "./sessionManager";

export const obterEstabelecimentoAtivoId = () => {
  try {
    const fromStorage = localStorage.getItem("estabelecimento_id");
    if (fromStorage) {
      const parsed = Number(fromStorage);
      if (Number.isFinite(parsed) && parsed > 0) return parsed;
    }

    const usuario = sessionManager.obterUsuario();
    const fromUser = usuario?.estabelecimento_id ?? usuario?.estabelecimento?.id;
    if (fromUser) {
      const parsed = Number(fromUser);
      if (Number.isFinite(parsed) && parsed > 0) return parsed;
    }
  } catch {
    // noop
  }

  return null;
};

export const resolverEstabelecimentoAtivoId = (informado) => {
  const id = informado ?? obterEstabelecimentoAtivoId();
  if (!id) {
    const erro = new Error("Nenhum estabelecimento ativo na sessão.");
    erro.code = "ESTABELECIMENTO_NAO_DEFINIDO";
    throw erro;
  }
  return id;
};
